import ClearIcon from '@mui/icons-material/Clear'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import Badge from '@mui/material/Badge'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import Radio from '@mui/material/Radio'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'
import { colors, componentSizes } from '@theme/variables'

export const ProfileCardContainer = styled(Card)`
  position: relative;
`

export const AppInner = styled('div')`
  margin: 0 auto;
`

export const SearchPageInner = styled('div')`
  width: 100%;
  display: flex;
`

export const FilterSectionContainer = styled('div')`
  width: 300px;
  margin-right: ${componentSizes.smDistance};
  flex-shrink: 0;
`

export const ContentSectionContainer = styled('div')`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
`

export const SearchInputSectionContainer = styled('div')`
  margin-bottom: 25px;
`

export const FilterAccordionDetails = styled(AccordionDetails)`
  padding: 16px 10px 14px;
`

export const FilterAccordion = styled(Accordion)`
  box-shadow: none;

  &.Mui-expanded ${FilterAccordionDetails} {
    border-top: 1px solid ${colors.lightGrey};
    border-bottom: 1px solid ${colors.lightGrey};
    margin-bottom: 13px;
  }
`

export const FilterBox = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

export const FilterClearIcon = styled(ClearIcon)`
  width: 16px;
  height: 16px;
`

export const FilterBadge = styled(Badge)`
  margin-left: 7px;
  top: -1px;
`

export const FilterExpandMoreIcon = styled(ExpandMoreIcon)`
  transform: ${({ opened }: { opened: boolean }) => (opened ? 'rotate(0)' : 'rotate(270deg)')};
  transition: 0.2s;
  fill: ${colors.bodyText};
  margin-left: -14px;
`

export const MultiLevelSelectWrap = styled(Box)`
  width: 100%;

  & + & {
    margin-top: 3px;
  }
`

export const MultiLevelSelectSummary = styled(Box)`
  display: flex;
  align-items: flex-start;
`

export const SelectCheckbox = styled(Checkbox)`
  padding: 0px 5px;
`

export const MultiSelectNestedWrap = styled(Box)`
  padding-left: 22px;

  & ${SelectCheckbox} {
    padding: 0;
  }
`

export const MultiSelectWrap = styled(Box)`
  display: flex;
  align-items: center;
  flex-direction: column;
`

export const MultiSelectAccordionDetails = styled(AccordionDetails)`
  padding: 0 0 0 4px;
`

export const SelectFormControlLabel = styled(FormControlLabel)`
  width: 100%;
  margin: 0;
  align-items: flex-start;

  & + & {
    margin-top: 5px;
  }

  .MuiRadio-root {
    padding: 0 3px 0 6px;
  }

  .MuiFormControlLabel-label {
    width: 100%;
    margin-top: 2px;
  }
`

export const SelectRadio = styled(Radio)`
  padding: 0;
`

export const MultiLevelSelectCheckbox = styled(Checkbox)`
  padding: 0px 5px 0px 0px;
  margin-left: -5px;
`

export const SelectLabelWrapper = styled('div')`
  display: flex;
  justify-content: space-between;
  width: 100%;
`

export const SelectLabelText = styled(Typography)`
  max-width: 155px;
  word-break: break-word;
`
